import { UserLoginForm, ForgetPasswordForm } from '../../../components/forms/user_login'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { Card } from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-coverflow'
import 'swiper/css/pagination'
import { Autoplay, EffectCoverflow, Pagination } from 'swiper/modules'
import { FaStar } from "react-icons/fa6"
import { LuCopyright } from "react-icons/lu"
import dashboard_img from '../../../assets/images/dashboard.png'
import planning_img from '../../../assets/images/planning.png'
import sales_order_img from '../../../assets/images/sales_order.png'
import delivery_planning_img from '../../../assets/images/delivery_planning.png'
import customer_details_img from '../../../assets/images/customer_details.png'

export const LoginImport = {
    UserLoginForm,
    ForgetPasswordForm,
    AOS,
    Card,
    Swiper,
    SwiperSlide,
    Autoplay,
    EffectCoverflow,
    Pagination,
    FaStar,
    LuCopyright,
    dashboard_img,
    planning_img,
    sales_order_img,
    delivery_planning_img,
    customer_details_img
}